<script>

    import { chargeStore } from '../stores'

    import ModalContainer from '../$components/modal.container.svelte'

    import AccountComponent from '../accounts/component.account.svelte'
    import AccountUpdateComponent from '../accounts/component.update.svelte'

    import AdviserComponent from './component.adviser.svelte'
    import OwnerComponent from './component.owner.svelte'

    import ChargeComponent from '../charges/component.charge.svelte'
    import ChargeCreateComponent from '../charges/component.create.svelte'
    
    import CreditCreateComponent from '../credits/component.create.svelte'
    import CreditRemoveComponent from '../credits/component.remove.svelte'

    import CreditComponent from '../credits/component.credit.svelte'
    import CreditUpdateComponent from '../credits/component.update.svelte'
    
    import SchemeCreateComponent from '../schemes/component.create.svelte'

    import FixedpriceCreateComponent from '../fixedprices/component.create.svelte'
    import FixedpriceUpdateComponent from '../fixedprices/component.update.svelte'
    import FixedPriceComponent from '../fixedprices/component.fixedprice.svelte'

    import AccountCreateComponent from '../accounts/component.create.svelte'
    
    import NotificationCreateComponent from '../notifications/component.create.svelte'
    import NotificationComponent from '../notifications/component.notification.svelte'
    import NotificationUpdateComponent from '../notifications/component.update.svelte'
    
    import PrepaidCreateComponent from '../prepaids/component.create.svelte'
    import PrepaidComponent from '../prepaids/component.prepaid.svelte'
    import PrepaidUpdateComponent from '../prepaids/component.update.svelte'
    
    import UserUpdateComponent from './component.update.svelte'
    import UserUpdateLocationComponent from './component.update.location.svelte'
    
</script>

<ModalContainer id="user_update_adviser_modal" title="Asignar asesor" >
    <AdviserComponent />
</ModalContainer>

<ModalContainer id="user_update_modal" title="Actualizar usuario" >
    <UserUpdateComponent />
</ModalContainer>

<ModalContainer id="user_update_location_modal" title="Actualizar dirección" >
    <UserUpdateLocationComponent />
</ModalContainer>

<ModalContainer id="credit_create_modal" title="Agregar credito" >
    <CreditCreateComponent />
</ModalContainer>

<ModalContainer id="credit_remove_modal" title="Remover credito" >
    <CreditRemoveComponent />
</ModalContainer>

<ModalContainer id="credit_modal" title="Credito" >
    <CreditComponent />
</ModalContainer>

<ModalContainer id="credit_update_modal" title="Actualizar credito" >
    <CreditUpdateComponent />
</ModalContainer>

<ModalContainer id="charge_modal" title="Cargo" >
    <ChargeComponent charge={ $chargeStore } />
</ModalContainer>

<ModalContainer id="charge_create_modal" title="Cargo" >
    <ChargeCreateComponent />
</ModalContainer>

<ModalContainer id="scheme_create_modal" title="Esquema" >
    <SchemeCreateComponent />
</ModalContainer>

<ModalContainer id="fixedprice_create_modal" title="Precios fijos" >
    <FixedpriceCreateComponent />
</ModalContainer>

<ModalContainer id="fixedprice_update_modal" title="Precios fijos" >
    <FixedpriceUpdateComponent />
</ModalContainer>

<ModalContainer id="fixedprice_modal" title="Precios fijos" >
    <FixedPriceComponent />
</ModalContainer>

<ModalContainer id="prepaid_create_modal" title="Prepago" >
    <PrepaidCreateComponent type="user" />
</ModalContainer>

<ModalContainer id="prepaid_modal" title="Prepago" >
    <PrepaidComponent />
</ModalContainer>

<ModalContainer id="prepaid_update_modal" title="Prepago" >
    <PrepaidUpdateComponent />
</ModalContainer>

<ModalContainer id="account_create_modal" title="Cuenta" >
    <AccountCreateComponent />
</ModalContainer>

<ModalContainer id="account_modal" title="Cuenta" >
    <AccountComponent />
</ModalContainer>

<ModalContainer id="account_update_modal" title="Cuenta" >
    <AccountUpdateComponent />
</ModalContainer>

<ModalContainer id="notification_create_modal" title="Notificación" >
    <NotificationCreateComponent type="user" />
</ModalContainer>

<ModalContainer id="notification_modal" title="Notificación" >
    <NotificationComponent />
</ModalContainer>

<ModalContainer id="notification_update_modal" title="Notificación" >
    <NotificationUpdateComponent />
</ModalContainer>